import { render, staticRenderFns } from "./MarathonTraining.vue?vue&type=template&id=2fd3c302&scoped=true&"
import script from "./MarathonTraining.vue?vue&type=script&lang=js&"
export * from "./MarathonTraining.vue?vue&type=script&lang=js&"
import style0 from "./MarathonTraining.vue?vue&type=style&index=0&id=2fd3c302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3c302",
  null
  
)

export default component.exports